<template>
  <modal
    ref="modal"
    :width="600"
    :scrollable="true"
    :click-to-close="false"
    height="auto"
    name="mta-payment-modal"
    class="mta-payment-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="closeMtaPaymentModal">
      <span class="icon">
        <img
          src="~/assets/images/icons/Close-button.svg"
          class="icon alt"
          alt="close icon"
        />
      </span>
    </div>
    <div v-if="!paymentError && !mtaQuoteError && paymentSuccess === null">
      <h2 class="hp-block-title">Premium Change</h2>
      <div class="price-table">
        <div class="row">
          <div class="">Current policy premium:</div>
          <div class="mta-price">
            {{
              $store.getters['mtaQuote/balance'].currentPolicyPremium
                | toCurrency
            }}
          </div>
        </div>
        <div class="row">
          <div class="">New policy premium:</div>
          <div class="mta-price">
            {{
              $store.getters['mtaQuote/balance'].newPolicyPremium | toCurrency
            }}
          </div>
        </div>
        <div class="row">
          <div class="">Additional gross premium:</div>
          <div class="mta-price">
            {{ $store.getters['mtaQuote/balance'].newGross | toCurrency }}
          </div>
        </div>
        <div class="row">
          <div class="">IPT:</div>
          <div class="mta-price">
            {{ $store.getters['mtaQuote/balance'].ipt | toCurrency }}
          </div>
        </div>
        <div v-if="isNegativePrice" class="row">
          <div class="">Return balance:</div>
          <div class="mta-price">
            {{
              $store.getters['mtaQuote/balance'].toBePaidReturnBalance
                | toCurrency
            }}
          </div>
        </div>
        <div v-else class="row">
          <div class="">Additional payment:</div>
          <div class="mta-price">
            {{
              $store.getters['mtaQuote/balance'].toBePaidReturnBalance
                | toCurrency
            }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAnnualStripeForm">
      <!-- <AnnualForm v-on:annual-payment="makePaymentWithCardDetails" /> -->
      <AnnualForm :mta-retry="true" />
    </div>
    <div v-if="paymentSuccess">
      <CongratsMessage
        :message="message"
        :description="description"
        :icon="icon"
      />
    </div>
    <div v-if="mtaPaymentCardlessError">
      {{ mtaPaymentCardlessError }}
    </div>
    <div v-if="mtaQuoteError">
      <span class="mta-payment-error">
        <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        <span>{{ mtaQuoteError }}</span>
      </span>
    </div>
    <button
      v-if="!paymentError && !mtaQuoteError && paymentSuccess === null"
      :class="{ 'is-loading': $nuxt.$loading.get() }"
      class="button ps-button is-fullwidth"
      @click="makePayment"
    >
      <span v-if="$store.getters['mtaQuote/balance'].newGross > 0">
        Make payment
      </span>
      <span v-else> Continue </span>
    </button>
    <button
      v-if="paymentSuccess || mtaQuoteError || mtaPaymentCardlessError"
      :class="{ 'is-loading': $nuxt.$loading.get() }"
      class="button ps-button is-fullwidth"
      @click="continueToDashboard"
    >
      Continue to dashboard
    </button>
  </modal>
</template>

<script>
/* eslint-disable no-console */
import { mapGetters, mapActions } from 'vuex'
import CongratsMessage from '@/components/common/CongratsMessage'
import AnnualForm from '@/components/payment/AnnualForm'
import { MODAL_TYPE } from '@/helpers'

export default {
  name: 'MtaPaymentModal',
  components: { CongratsMessage, AnnualForm },
  data() {
    return {
      type: '',
      description:
        'A new certificate will be emailed to you to reflect your policy changes.',
      icon: ['far', 'check-circle'],
    }
  },
  computed: {
    ...mapGetters({
      mtaPaymentCardlessError: 'mtaQuote/mtaPaymentCardlessError',
    }),
    paymentSuccess() {
      return (
        this.$store.getters['mtaQuote/mtaPaymentAnnuallyStatus'] ||
        this.$store.getters['mtaQuote/mtaPaymentMonthlyStatus'] ||
        this.$store.getters['mtaQuote/mtaPaymentCardlessStatus'] ||
        this.$store.getters['mtaQuote/mtaPaymentRetryStatus']
      )
    },
    paymentError() {
      return (
        this.$store.getters['mtaQuote/mtaPaymentAnnuallyError'] ||
        this.$store.getters['mtaQuote/mtaPaymentMonthlyError'] ||
        this.$store.getters['mtaQuote/mtaPaymentRetryError'] ||
        this.$store.getters['mtaQuote/mtaPaymentCardlessError']
      )
    },
    isNegativePrice() {
      return this.$store.getters['mtaQuote/balance'].toBePaidReturnBalance < 0
    },
    mtaQuoteError() {
      return this.$store.getters['mtaQuote/mtaQuoteError']
    },
    message() {
      return `${MODAL_TYPE[this.type]} updated!`
    },
    showAnnualStripeForm() {
      return (
        this.paymentError &&
        !this.paymentSuccess &&
        !this.mtaPaymentCardlessError
      )
    },
  },
  mounted() {},
  methods: {
    ...mapActions('mtaQuote', {
      payMtaQuoteAnnually: 'payMtaQuoteAnnually',
      payMtaQuoteMonthly: 'payMtaQuoteMonthly',
      payMtaQuoteCardless: 'payMtaQuoteCardless',
      resetMtaQuote: 'resetMtaQuote',
      retryMtaPayment: 'retryMtaPayment',
    }),
    beforeOpen(event) {
      console.log('event', event)
      this.type = event.params.type
    },
    async beforeClose(event) {
      await this.$router.replace(
        `/dashboard/policy/${this.$route.params.quoteid}`
      )
      this.resetMtaQuote()
      // this.$modal.hide('mta-payment-modal')
    },
    async closeMtaPaymentModal() {
      await this.$router.replace(
        `/dashboard/policy/${this.$route.params.quoteid}`
      )
      this.resetMtaQuote()
    },
    async makePayment() {
      if (this.$store.getters['mtaQuote/mtaQuote'].payment_method === 1) {
        console.log('Stripe')
        await this.payMtaQuoteAnnually(this.$store.getters['mtaQuote/mtaQuote'])
      }
      if (this.$store.getters['mtaQuote/mtaQuote'].payment_method === 2) {
        console.log('Premfina')
        await this.payMtaQuoteMonthly(this.$store.getters['mtaQuote/mtaQuote'])
      }
      if (this.$store.getters['mtaQuote/mtaQuote'].payment_method === 12) {
        console.log('GoCardless')
        await this.makeCardlessPayment()
      }
    },
    async makeCardlessPayment() {
      await this.payMtaQuoteCardless({
        quote: this.$store.getters['mtaQuote/mtaQuote'],
      })
    },
    // TODO delete makePaymentWithCardDetails after SCA we are not using it
    async makePaymentWithCardDetails(paymentData) {
      await this.retryMtaPayment({
        quote: this.$store.getters['mtaQuote/mtaQuote'],
        card: paymentData.cardDetails,
      })
    },
    async continueToDashboard() {
      await this.$router.replace(
        `/dashboard/policy/${this.$route.params.quoteid}`
      )
      this.resetMtaQuote()
      // this.$modal.hide('mta-payment-modal')
    },
  },
}
</script>

<style lang="scss">
.mta-payment-modal {
  background: rgba(0, 0, 0, 0.5);
  .ps-button {
    margin: 50px 0 0 0;
    &:hover,
    &:focus {
      color: $white;
    }
  }
  .close-icon-container {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  }
  .v--modal-box {
    @include mobile {
      width: calc(100% - 40px) !important;
      margin: 0 auto !important;
      left: 0 !important;
      padding: 50px 20px 20px;
    }
    @include tablet {
      padding: 50px;
    }
  }
  .mta-payment-error {
    color: red;
  }
}
</style>

<style lang="scss" scoped>
.mta-price {
  color: $ps-primary;
}
.price-table {
  font-size: 1.2rem;
  @include tablet {
  }
  .row {
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    .mta-price {
      flex-grow: 1;
      text-align: right;
    }
  }
}
</style>
